export default __webpack_public_path__ + "60e1a679bfe58cc2154bc52cd565ff9c.gif";